import BOMViewPage from './BOMViewPage';

export default BOMViewPage;
